import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  private http = inject(HttpClient);
  private baseUrl = environment.baseUrl + '/api/News';

  getNews(page: number = 1, pageSize: number = 9): Observable<any> {
    let params = new HttpParams()
      .set('CurrentPage', page.toString())
      .set('PageSize', pageSize.toString());

    return this.http.get<any>(this.baseUrl, { params });
  }

  getNewsById(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${id}`);
  }
}
